module.exports = __webpack_public_path__ + "media/src/images/logos/mass-media/india-5e4fbcb6276cb83e3ebadff9f2dfbbda.svg";